<template>
<div class="box">
  <div class="list-view" ref="listView">
    <ul>
      <li v-for="(item, key) in addressList" class="list-item" :key="key" @click="click(item)">
        <p class="place">{{ item.name }}</p>
        <p class="address">{{ item.address ?  item.address : ''}}</p>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import BScroll from 'better-scroll';
export default _extend({
  name: 'SlidingList',
  props: {
    addressList: {
      type: Array,
      default: []
    },
    callBack: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
    };
  },
  methods: {
    _initScroll () {
      this.scroll = new BScroll(this.$refs.listView, {
        probeType: 3,
        click: true
      });
    },
    click(item) {
      this.callBack(item);
    }
  },
  computed: {
    list() {
      return this.addressList;
    }
  },
  watch: {
    list() {
      if (this.scroll) {
        this.scroll.scrollTo(0, 0);
      }
    }
  },
  created() {
    setTimeout(() => {
      this._initScroll();
    }, 20);
  }
});
</script>

<style lang="scss" scoped>
@import './SlidingList.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlidingList/SlidingList.vue